import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

/**
 * Reusable Confirmation Modal Component
 *
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} toggle - Function to toggle modal
 * @param {function} onConfirm - Function called when user confirms
 * @param {string} title - Modal title (default: "Confirm Action")
 * @param {string} message - Confirmation message
 * @param {string} confirmText - Confirm button text (default: "Confirm")
 * @param {string} cancelText - Cancel button text (default: "Cancel")
 * @param {string} confirmColor - Confirm button color (default: "primary")
 * @param {string} icon - Icon class to show (optional)
 * @param {boolean} loading - Whether action is in progress
 */
const ConfirmModal = ({
  isOpen,
  toggle,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  icon = null,
  loading = false,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="border-bottom">
        <span className="d-flex align-items-center">
          {icon && <i className={`${icon} mr-2`} style={{ fontSize: "1.2rem" }}></i>}
          {title}
        </span>
      </ModalHeader>
      <ModalBody className="py-4">
        <div className="text-center">
          {icon && (
            <div className="mb-3">
              <i
                className={icon}
                style={{
                  fontSize: "3rem",
                  color:
                    confirmColor === "danger"
                      ? "var(--brand-danger, #dc3545)"
                      : confirmColor === "warning"
                      ? "var(--brand-warning, #ffc107)"
                      : confirmColor === "success"
                      ? "var(--brand-success, #28a745)"
                      : "var(--brand-accent, #5bbf4a)",
                }}
              ></i>
            </div>
          )}
          <p className="mb-0" style={{ fontSize: "1rem" }}>
            {message}
          </p>
        </div>
      </ModalBody>
      <ModalFooter className="border-top">
        <Button color="light" onClick={toggle} disabled={loading}>
          {cancelText}
        </Button>
        <Button color={confirmColor} onClick={handleConfirm} disabled={loading}>
          {loading ? (
            <>
              <i className="bx bx-loader bx-spin mr-1"></i>
              Processing...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
